import React, { useEffect, useState } from "react";
import "./CustomerLogs.css";

const ITEMS_PER_PAGE = 40;

const AgentLogs = () => {
  const [agentLogs, setAgentLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetch("/dashboard/agent-logs", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setAgentLogs(data.agentLogs || []))
      .catch((err) => console.error("Error fetching agent logs:", err));
  }, []);

  const formatTime = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    return date.toLocaleString("th-TH", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const totalPages = Math.ceil(agentLogs.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedLogs = agentLogs.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  return (
    <div className="dashboard-container">
      <div>
        <div className="logs-section-horizontal">
          <h2 className="cus-info-title">Agent Login Logs</h2>
          <div className="dashboard-card-horizontal">
            <table className="logs-table">
              <thead className="logs-table-header">
                <tr>
                  <th className="logs-table-head">Email</th>
                  <th className="logs-table-head">Time</th>
                  <th className="logs-table-head">Status</th>
                </tr>
              </thead>

              <tbody>
                {paginatedLogs.length > 0 ? (
                  paginatedLogs.map((log) => (
                    <tr key={log.id} className="logs-table-row">
                      <td className="logs-table-cell">{log.email}</td>
                      <td className="logs-table-cell">
                        {formatTime(log.login_time)}
                      </td>
                      <td className="logs-table-cell">
                        <span
                          className={
                            Number(log.status) === 1
                              ? "log-status-badge log-status-success"
                              : "log-status-badge log-status-failed"
                          }
                        >
                          {Number(log.status) === 1 ? "Success" : "Failed"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="logs-table-cell" colSpan="3">
                      ไม่พบข้อมูล
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div className="ticket-pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={currentPage === page ? "active-page" : ""}
                  >
                    {page}
                  </button>
                );
              })}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentLogs;
